
import { SearchSettings } from '../../typings/search-settings';

export const FretSearchSettings: SearchSettings = {
    facets: [
        {
            id: 'datatype',
            title: 'Art der Daten',
            facetKeys: ['docTyp.name']
        },
        {
            id: 'wellen',
            title: 'Wellen',
            facetKeys: [
                '8_facet_ps_wellen',
                '6_facet_vw_gen_wellen',
                '5_facet_us_welle',
                '4_facet_uw_id'
            ]
        },
        {
            id: 'personen',
            title: 'Probanden',
            facetKeys: [
                '8_facet_ps_nameindex',
                '5_facet_us_pseudonym_proband',
                '6_vw_gen_probanden'
            ]
        },
        {
            id: 'geschlecht',
            title: 'Geschlecht',
            facetKeys: [
                '5_us_geschlecht_proband.content',
                '8_ps_gender.content'
                ]
        },
        {
            id: 'kohorte',
            title: 'Kohorte',
            facetKeys: [
                '8_facet_ps_kohorte',
                '5_facet_us_kohorte'
            ]
        },
        {
            id: 'tests',
            title: 'Tests',
            facetKeys: [
                '3_facet_pt_titel',
                '4_facet_uw_tests',
                '5_facet_iw_tests',
                '6_facet_vw_gen_tests',
                '8_facet_tests',
            ]
        },
        {
            id: 'sachindex',
            title: 'Sachindex',
            facetKeys: [
                '2_facet_st_stichworte_dt',
                '3_facet_pt_schlagwoerter',
                '4_facet_uw_schlagwoerter',
                '5_facet_iw_schlagwoerter_neu',
                '6_facet_vw_schlagwoerter',
                '8_facet_ps_schlagwoerter'
            ]
        },
        {
            id: 'testArt',
            title: 'Testart',
            facetKeys: ['3_facet_pt_form']
        },



    ],
    validDocTypes: ['doctyp8', 'doctyp6', 'doctyp5', 'doctyp4', 'doctyp3', 'doctyp2']
};
